/**
 * Created by evgenijsenkevic on 23/7/25
 */

cleverapps.overrideFonts(cleverapps.styles.FONTS, {
    COLLECTION_WINDOW_TEXT: {
        name: "default",
        size: 45,
        color: cleverapps.styles.COLORS.STICKER_LABEL_COLOR
    },

    STICKERS_COLLECTION_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.WHITE
    },

    COLLECTION_BADGE_TEXT: {
        size: 35
    },

    STICKERS_AVAILABLE_TEXT: {
        size: 40,
        color: cleverapps.styles.COLORS.STICKER_LABEL_COLOR
    },

    STICKERS_PROGRESS_BAR_TEXT: {
        size: 38
    },

    STICKER_JOKER_BUTTON_TEXT: {
        size: 80,
        color: cleverapps.styles.COLORS.WHITE,
        stroke: cleverapps.styles.DECORATORS.TRANSPARENT_BLACK_2PX
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersBookJokerView, {
    bg: {
        width: 135,
        height: 60,
        x: { align: "right", dx: -40 },
        y: { align: "center" }
    },
    text: {
        x: { align: "center", dx: -20 },
        y: { align: "center" }
    },
    withBillet: true
});

cleverapps.overrideStyles(cleverapps.styles.StickersBookWindow, {
    size: [
        { width: 900, height: 1120 },
        { width: 1500, height: 1010 },
        { width: 1500, height: 1010 }
    ],

    scroll: {
        size: [
            { width: 900, height: 940 },
            { width: 1460, height: 900 },
            { width: 1460, height: 900 }
        ],
        position: [
            { x: { align: "center" }, y: { align: "center", dy: -59 } },
            { x: { align: "center", dx: -2 }, y: { align: "center", dy: -45 } },
            { x: { align: "center", dx: -2 }, y: { align: "center", dy: -45 } }
        ]
    },

    fg: undefined,

    jokers: {
        position: [
            { x: { align: "right", dx: -34 }, y: { align: "top", dy: -15 } },
            { x: { align: "right", dx: -42 }, y: { align: "top", dy: -17 } },
            { x: { align: "right", dx: -42 }, y: { align: "top", dy: -17 } }
        ]
    },

    progressView: {
        width: 350,
        verticalWidth: 283,
        position: [
            { x: { align: "center", dx: 50 }, y: { align: "top", dy: -40 } },
            { x: { align: "center", dx: 40 }, y: { align: "top", dy: -42 } },
            { x: { align: "center", dx: 40 }, y: { align: "top", dy: -42 } }
        ],
        joker: [
            { x: { align: "left", dx: -50 }, y: { align: "center" } },
            { x: { align: "left", dx: -20 }, y: { align: "center" } },
            { x: { align: "left", dx: -20 }, y: { align: "center" } }
        ],
        text: {
            dy: -1
        }
    },

    grid: {
        margin: {
            x: 2,
            y: -5
        },
        padding: {
            top: 30,
            right: 10
        }
    },

    collectionsAmount: {
        position: [
            { x: { align: "left", dx: 32 }, y: { align: "top", dy: -19 } },
            { x: { align: "left", dx: 43 }, y: { align: "top", dy: -21 } },
            { x: { align: "left", dx: 43 }, y: { align: "top", dy: -21 } }
        ]
    },

    stickersAmount: {
        position: [
            { x: { align: "left", dx: 248 }, y: { align: "top", dy: -51 } },
            { x: { align: "left", dx: 300 }, y: { align: "top", dy: -20 } },
            { x: { align: "left", dx: 300 }, y: { align: "top", dy: -20 } }
        ]
    }

});

cleverapps.overrideStyles(cleverapps.styles.StickersCollectionIcon, {
    textBg: undefined,

    title: {
        maxWidth: 215,
        maxHeight: 42,
        x: { align: "center", dx: 0 },
        y: { align: "top", dy: -27 },
        unavailableOpacity: undefined
    },

    icon: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: -20 }
    },

    prizebar: {
        x: { align: "center" },
        y: { align: "center", dy: 20 },
        width: 160,
        checkmark: {
            x: { align: "center", dx: 0 },
            y: { align: "center", dy: 10 }
        },
        text: {
            dy: -1
        },
        button: {
            y: { align: "center", dy: 15 }
        }
    },
    margin: -10,
    availableText: {
        y: { align: "center", dy: 15 }
    },
    badge: {
        x: { align: "right", dx: 10 },
        y: { align: "top", dy: 0 },
        text: false
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersCollectionWindow, {
    size: [
        { width: 1000, height: 1300 },
        { width: 1000, height: 1300 },
        { width: 1670, height: 870 }
    ],

    prize: {
        width: 400,
        position: [
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -34 } },
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -34 } },
            { x: { align: "center" }, y: { align: "top", dy: -35 } }
        ]
    },

    finish: {
        position: [
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -34 } },
            { x: { align: "center", dx: 0 }, y: { align: "top", dy: -34 } },
            { x: { align: "center" }, y: { align: "top", dy: -35 } }
        ]
    },

    jokers: {
        position: [
            { x: { align: "right", dx: -49 }, y: { align: "top", dy: -24 } },
            { x: { align: "right", dx: -49 }, y: { align: "top", dy: -24 } },
            { x: { align: "right", dx: -56 }, y: { align: "top", dy: -26 } }
        ]
    },

    text: {
        dy: -1
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersComponent, {
    fg: false,
    layout: {
        margin: [{ x: 30, y: 20 }, { x: 30, y: 20 }, { x: 40, y: 45 }],
        x: { align: "center" },
        y: { align: "center", dy: -66 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickersRewardWindow, {
    stickers: {
        margin: {
            x: 80,
            y: 120
        }
    },
    source: {
        y: { align: "bottom", dy: -50 }
    }
});

cleverapps.overrideStyles(cleverapps.styles.StickerView, {
    label: {
        textBg: false,
        text: {
            x: { align: "center", dx: 0 },
            y: { align: "bottom", dy: 20 },
            width: 240
        }
    },

    image: {
        x: { align: "center" },
        y: { align: "center", dy: 30 }
    },

    tape: {
        x: { align: "center" },
        y: { align: "top", dy: 30 },
        rotation: [-75, -75, 0]
    }
});